import axios from "axios";
import { DocumentType} from "../types";


//const apiUrl: string = "https://slrd9ypjsg.execute-api.eu-west-1.amazonaws.com/my-iris-documents";
const apiUrl:string = process.env.REACT_APP_API_URL_ROOT + "/documents"

const fetchAlerts = async (user_signature: string, auth:string, cat?:string): Promise<DocumentType[]> => {

   try {
    const response = await axios.get(apiUrl, {
        params: cat? {
          user_signature: user_signature,
          category:  cat
        } : 
        {
          user_signature: user_signature,
        },
        headers: {'Authorization': auth},
      });

     if (response === undefined) throw new Error("Response is undefined");
      
     const result:DocumentType[] = response.data;
     return result;
   } catch (error: any) {
     if (axios.isAxiosError(error)) {
       if (error.response?.status === 500){
       console.log(error)
        throw new Error("Internal server error")}
       if (error.response?.status === 404){
        console.log(error)
         throw new Error("The resource was not found");}
    }
    console.log(error)
     throw error;
  }

};

export default fetchAlerts;
